import { IconCheck, IconLoading02 } from '@/components'
import { Integration } from '@/models'

export const TeslaIntegrationSetupAlert = ({ integration }: { integration: Integration }) => {
    if (integration?.isComplianceNotVerified) {
        return <div className="w-full flex justify-between items-start gap-3 my-4 px-6 py-3 text-purple-500 bg-purple-50 text-xs rounded-xl">
            <div className="leading-4.5">
                <h4 className="font-semibold">Integration Setup Not Yet Confirmed:</h4>
                <p className="text-gray-600">
                    We have not yet received a warranty in the Daybreak platform. Please ensure Solar Insure is listed
                    as a partner on any new device.
                </p>
            </div>
            <div className="rounded-full flex justify-center items-center bg-purple-100 w-8 h-8">
                <IconLoading02 className="stroke-purple-600" size="sm"/>
            </div>
        </div>
    }
    if (integration?.isComplianceVerified) {
        return <div className="w-full flex justify-between items-start gap-3 my-4 px-6 py-3 text-success-500 bg-success-50 text-xs rounded-xl">
            <div className="leading-4.5">
                <h4 className="font-semibold">Integration Setup Confirmed:</h4>
                <p className="text-gray-600">
                    We’ve received at least one warranty in the Daybreak platform that’s also in PowerHub. Please
                    continue listing Solar Insure as a partner, and thank you for your cooperation.
                </p>
            </div>
            <div className="rounded-full flex justify-center items-center bg-success-100 w-8 h-8">
                <IconCheck className="stroke-success-600" size="sm"/>
            </div>
        </div>
    }

    return null
}
